(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    class ProductPriceComponent extends HTMLElement {
    connectedCallback() {
      this.unitPrice = parseInt(this.dataset.unitPrice, 10) || 0;
      this.moneyFormat = this.dataset.moneyFormat || '₹{{amount}}';
      this.priceEl = this.querySelector('.price');

      this.handleUpdate = this.handleUpdate.bind(this);
      document.addEventListener('quantity-selector:update', this.handleUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('quantity-selector:update', this.handleUpdate);
    }

    handleUpdate(event) {
      // Ignore cart-line quantity selectors (cart page) - only react to the PDP selector
      if (event.detail.cartLine !== undefined) return;
      if (!this.priceEl || !this.unitPrice) return;

      const selector = event.target.closest ? event.target.closest('quantity-selector-component') : null;
      if (!selector) return;

      // Only react if this event came from the quantity selector for OUR variant
      const selectorVariantId = selector.dataset.variantId;
      if (this.dataset.variantId && selectorVariantId && selectorVariantId !== this.dataset.variantId) {
        return;
      }

      const quantity = event.detail.quantity || 1;
      const total = this.unitPrice * quantity;
      this.priceEl.textContent = this.formatMoney(total);
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      const [whole, decimals] = amount.split('.');
      return this.moneyFormat
        .replace('{{amount}}', `${whole}.${decimals}`)
        .replace('{{ amount }}', `${whole}.${decimals}`)
        .replace('{{amount_no_decimals}}', whole)
        .replace('{{ amount_no_decimals }}', whole);
    }
  }

  if (!customElements.get('product-price')) {
    customElements.define('product-price', ProductPriceComponent);
  }




  document.addEventListener("click", function(e){

    document.querySelectorAll(".info-popup-panel").forEach(function(panel){

        if(!panel.parentElement.contains(e.target)){
            panel.classList.remove("active");
        }

    });

});
  } catch(e) { console.error(e); }
})();

})();
